/* ==========================================================================
   UiPopper > Client > Store > Actions
   ========================================================================== */

/* Types */
const DESTROY = 'UIPOPPER::DESTROY';
const DISPLAY = 'UIPOPPER::DISPLAY';
const HIDE = 'UIPOPPER::HIDE';

/* Actions */
const destroy = () => ({ type: DESTROY });
const display = () => ({ type: DISPLAY });
const hide = () => ({ type: HIDE });

/* Exports */
module.exports = {
    types: {
        DESTROY,
        DISPLAY,
        HIDE
    },
    actions: {
        destroy,
        display,
        hide
    }
};
